import { render, staticRenderFns } from "./selectLanguage.vue?vue&type=template&id=722092b3"
import script from "./selectLanguage.vue?vue&type=script&lang=js"
export * from "./selectLanguage.vue?vue&type=script&lang=js"
import style0 from "./selectLanguage.vue?vue&type=style&index=0&id=722092b3&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports